import { c as _c } from "react/compiler-runtime";
import type { VaultValue } from '@onefootprint/core';
import { IcoInfo16 } from '@onefootprint/icons';
import type { DataIdentifier } from '@onefootprint/request-types/dashboard';
import { LinkButton } from '@onefootprint/ui';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { WithEntityProps } from '@/entity/components/with-entity';
import useField from '../../hooks/use-field';
import type { DiField } from '../../vault.types';
import Field from '../field';
import Fieldset from '../fieldset';
import StreetViewDialog from './components/street-view-dialog';
export type AddressFieldsetProps = WithEntityProps & {
  fields: DiField[];
  title: string;
};
const AddressFieldset = t0 => {
  const $ = _c(28);
  const {
    entity,
    fields,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [streetViewDialogOpen, setStreetViewDialogOpen] = useState(false);
  const getFieldProps = useField(entity);
  let t2;
  if ($[1] !== fields || $[2] !== getFieldProps) {
    let t3;
    if ($[4] !== getFieldProps) {
      t3 = field => {
        const value = getFieldProps(field.di).value;
        return [field.di, typeof value === "string" ? value : ""];
      };
      $[4] = getFieldProps;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = Object.fromEntries(fields.map(t3));
    $[1] = fields;
    $[2] = getFieldProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const addressValues = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setStreetViewDialogOpen(false);
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const closeStreetViewDialog = t3;
  let t4;
  if ($[7] !== entity) {
    t4 = field_0 => {
      const {
        di,
        renderCustomField
      } = field_0;
      return renderCustomField ? <Fragment key={di}>{renderCustomField({
          entity,
          di
        })}</Fragment> : <Field key={di} di={di} entity={entity} />;
    };
    $[7] = entity;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const renderField = t4;
  let t5;
  if ($[9] !== addressValues || $[10] !== t) {
    t5 = () => {
      const validAddressValues = Object.values(addressValues).filter(_temp);
      const hasDecryptedFullAddress = validAddressValues.length >= 5;
      if (hasDecryptedFullAddress) {
        return <LinkButton onClick={() => setStreetViewDialogOpen(true)}>{t(_temp2)}</LinkButton>;
      }
      return <div className="flex items-center gap-2"><IcoInfo16 color="tertiary" /><div className="text-body-2 text-tertiary">{t(_temp3)}</div></div>;
    };
    $[9] = addressValues;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const renderStreetViewToggle = t5;
  let t6;
  if ($[12] !== fields || $[13] !== renderField) {
    t6 = fields.map(renderField);
    $[12] = fields;
    $[13] = renderField;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== renderStreetViewToggle) {
    t7 = <div className="flex pt-3 pb-1.5">{renderStreetViewToggle()}</div>;
    $[15] = renderStreetViewToggle;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== fields || $[18] !== t6 || $[19] !== t7 || $[20] !== title) {
    t8 = <Fieldset fields={fields} title={title}>{t6}{t7}</Fieldset>;
    $[17] = fields;
    $[18] = t6;
    $[19] = t7;
    $[20] = title;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== addressValues || $[23] !== streetViewDialogOpen) {
    t9 = streetViewDialogOpen && <StreetViewDialog onClose={closeStreetViewDialog} addressValues={addressValues} />;
    $[22] = addressValues;
    $[23] = streetViewDialogOpen;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t8 || $[26] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
export default AddressFieldset;
function _temp(value_0) {
  return !!value_0;
}
function _temp2($) {
  return $.address.streetView.seeStreetView;
}
function _temp3($_0) {
  return $_0.address.streetView.decryptData;
}